<script lang="ts">
  import { deleteWithJwt, getWithJwt, serverlessRoutes, translate } from "lib";
  import { user } from "stores";
  import { Svg } from "ui";
  import { parseDateWithTime } from "../../lib/parseDateWithTime";
  import { bookmarkedMessages } from "../../stores/bookmarkedMessages";

  const deleteBookmark = async (id: number): Promise<void> => {
    const url = `${serverlessRoutes.BOOKMARK}?bookmarkId=${id}`;
    try {
      await deleteWithJwt(url);
      $bookmarkedMessages = $bookmarkedMessages.filter(
        (message) => message.id !== id
      );
      bookmarkedMessages.generateBorder();
    } catch (err) {}
  };
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="p-4 flex flex-col gap-4">
  {#if $bookmarkedMessages.length}
    {#each $bookmarkedMessages as message}
      <div class="
        pb-4
        flex
        flex-col
        gap-4
        {message.showBorder ? "border-b-2 border-slate-300 dark:border-zinc-600" : ""}
      ">
        <div class="text-xs text-center">
          {parseDateWithTime(message.createdAt)}
        </div>

        <div>
          <!-- <div class="ml-2 text-xs font-bold">{message.senderName}:</div> -->
          <div class="flex justify-between gap-4">
            <div
              class="
                w-fit px-2.5 py-1.5 {
                  message.senderId === $user.id ? "bg-primary-700 text-slate-100 dark:text-slate-100" : "border border-slate-300 dark:border-zinc-600 text-slate-900 dark:text-slate-100"
                }
                rounded-2xl text-xs font-sans text-justify overflow-hidden
                my-wrap
              "
            >
              {message.payload}
            </div>
            <Svg
              name="delete"
              size={24}
              customColor="bg-red-500"
              on:click={() => deleteBookmark(message.id)}
            />
          </div>

        </div>
      </div>
    {/each}
  {:else}
    {translate("NO_BOOKMARKED_MESSAGES_YET")}
  {/if}
</div>

<style>
  /* nema tailwind klasa za ovo, ako se pojavi u buduce verzije ovde da se obrise */
  .my-wrap {
    overflow-wrap: break-word;
  }
</style>
